module.exports = __webpack_public_path__ + "static/media/599702_5.ff812228.pdf";